import { createHistoryLogModule } from '@izimi/modules';

import { historyLogApi } from '../di';

export const historyLogModule = createHistoryLogModule({ historyLogApi });
